import { FormFieldConfig } from "../types/formField.types";
import * as Yup from 'yup';
import { formatDateTime } from "./date";
import { statusOptions, trueFalseOptions } from "./options";
export const optionsField =  ['select', 'checkbox', 'radio', 'switch'];
export const statusField = (): FormFieldConfig => ({
    name: 'status',
    label: 'Status',
    type: 'select',
    yup: Yup.string().required('Status is required'), 
    getInitialValue: (data) => data?.status || 'Active',
    options: statusOptions,
    example: 'Active',
});
export const emailField = (): FormFieldConfig => ({
    name: 'email',
    label: 'Email',
    type: 'text',
    yup: Yup.string().email('Invalid email format').required('Email is required'), 
    getInitialValue: (data) => data?.email || '',
    table: { minWidth: 300 },
    example: 'test@gmail.com',
});
export const phoneField = (): FormFieldConfig => ({
    name: 'phone',
    label: 'Phone',
    type: 'text',
    getInitialValue: (data) => data?.phone || '',
    yup: Yup.string()
        .matches(/^\d{10}$/, 'Phone number should be 10 digits')
        .required('Phone is required'),
    example: '+1234567890',
    table: { minWidth: 200 },
});
export const createdAtField = (): FormFieldConfig => ({
    name: 'createdAt',
    label: 'Created At',
    showOn: ['table'],
    table: {
        valueFormatter: (params) => formatDateTime(params.value),
        minWidth: 200,
    },
    example: '2025-06-30T12:00:00Z',
});
export const updatedAtField = (): FormFieldConfig => ({
    name: 'updatedAt',
    label: 'Updated At',
    showOn: ['table'],
    table: {
        valueFormatter: (params) => formatDateTime(params.value),
        minWidth: 200,
    },
    example: '2025-06-30T12:00:00Z',
});
export const softDeletedField = (): FormFieldConfig => ({
    name: 'softDeleted',
    label: 'Soft Deleted',
    type: 'checkbox',
    options:trueFalseOptions,
    showOn: ['table'],
    table: {
        valueGetter: (params) => (params.data?.softDeleted ? 'Yes' : 'No'),
    },
    example: false,
});
export const createdByField = (): FormFieldConfig => ({
    name: 'createdBy',
    label: 'Created By',
    getInitialValue: (data) => {
        if (typeof data?.createdBy === 'object') return data?.createdBy?._id || '';
        return data?.createdBy || '';
    },
    table: {
        valueGetter: (params) => {
            const item = params.data?.createdBy;
            return typeof item === 'object' ? item.name : item;
        },
        minWidth: 200 ,
    },
    showOn: ['table'],
    example: 'Admin',
});
export const updatedByField = (): FormFieldConfig => ({
    name: 'updatedBy',
    label: 'Updated By',
    getInitialValue: (data) => {
        if (typeof data?.updatedBy === 'object') return data?.updatedBy?._id || '';
        return data?.updatedBy || '';
    },
    table: {
        valueGetter: (params) => {
            const item = params.data?.updatedBy;
            return typeof item === 'object' ? item.name : item;
        },
        minWidth: 220,
    },
    showOn: ['table'],
    example: 'Admin',
});
export const roleField = (): FormFieldConfig => ({
    name: 'role',
    label: 'Role',
    type: 'select',
    yup: Yup.string().required('Role is required'), 
    getInitialValue: (data) => {
        if (typeof data?.role === 'object') return data?.role?._id || '';
        return data?.role || '';
    },
    table: {
        valueGetter: (params) => {
            const role = params.data?.role;
            return typeof role === 'object' ? role.name : role;
        },
        minWidth: 200 ,
    },
    example: 'Admin', 
}); 
//export const  aaaaField = (): FormFieldConfig => ();